import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import Room from "../components/Room";
import AOS from "aos";
import "aos/dist/aos.css";
import swal from "sweetalert2";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Mybookngs from "./Mybookngs";
const { TabPane } = Tabs;

function Profile() {
	const user = JSON.parse(localStorage.getItem("currentuser"));
	const navigate = useNavigate();
	useEffect(() => {
			AOS.init({ duration: 500 });
		if (!user) {
			navigate("/login");
		}
	}, []);

	return (
		<div data-aos="fade-up" className="ml-3 mt-3">
			<Tabs defaultActiveKey="1">
				<TabPane tab="Profile" key="1">
					<h1>My Profile</h1>
					<br />
					<h1>Name: {user.name}</h1>
					<h1>Email: {user.email}</h1>
					<h1>isAdmin: {user.isAdmin ? "YES" : "NO"}</h1>
				</TabPane>
				<TabPane tab="Bookings" key="2">
					<Mybookngs />
				</TabPane>
			</Tabs>
		</div>
	);
}

export default Profile;
